var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"featured_text",style:(_vm.cssVars)},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"inner",class:_vm.theme,domProps:{"innerHTML":_vm._s(_vm.text)}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }


// WEBPACK FOOTER //
// ./scripts/vue/FeaturedText.vue